import { URLS } from "Common/urls";
import { createContext, useContext, useState } from "react";
import RestService from "Services/RestService";
import { SysBrewAuthProvider, useSysBrewAuth } from "SysBrewAuthProvider";

export const AUTH_TOKEN = "auth_token"
const UserContext = createContext()

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({})

    return (
        <SysBrewAuthProvider>
            <UserContext.Provider value={{
                user,
                setUser,
            }}>{
                    children}
            </UserContext.Provider>
        </SysBrewAuthProvider>
    )
}

const throwError = hook => {
    throw new Error(`${hook} must be used within a AuthProvider`)
}

const useAuth = () => {
    const {
        user,
        retry,
    } = useContext(UserContext)
    const { user: authUser, isLoading, error, isAuthenticated, logout: authLogout, token, removeToken, removeUser } = useSysBrewAuth()

    if (user === undefined) throwError("useAuth")

    const clearSession = () => {
        removeToken()
        removeUser()
    }

    const logout = () => {
        RestService.delete(URLS.UNREGISTER_NOTIFICATION_URL)
            .then(() => {
                console.log("Logged out")
            }).catch(error => {
                console.error(error)
            }).finally(() => {
                clearSession()
                authLogout({ returnTo: window.location.origin })
            })
    }

    const isAdmin = () => {
        // TODO
        return false
    }

    const isSuperAdmin = () => {
        // TODO
        return false
    }

    return {
        isLoading,
        error,
        isAuthenticated,
        logout,
        clearSession,
        getAccessToken: token,
        retry,
        user: authUser,
        isSuperAdmin: isSuperAdmin(),
        isAdmin: isAdmin(),
    }
}

export { AuthProvider, useAuth }